import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-299fd0eb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "spinner-container" }
const _hoisted_2 = ["width", "height"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  class: "path",
  cx: "25",
  cy: "25",
  r: "20",
  fill: "none",
  "stroke-width": "4"
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock("svg", {
      width: _ctx.size,
      height: _ctx.size,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 50 50",
      class: "spinner-svg"
    }, _hoisted_4, 8, _hoisted_2))
  ]))
}